import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyDg7lO0ZnDC4z0DIyKfWSKdOXi2oYX-JwM',
  authDomain: 'ssangkyomembership.firebaseapp.com',
  databaseURL: 'https://ssangkyomembership-default-rtdb.firebaseio.com',
  projectId: 'ssangkyomembership',
  storageBucket: 'ssangkyomembership.firebasestorage.app',
  messagingSenderId: '890315333170',
  appId: '1:890315333170:web:179e5f8371f39ad824662b',
  measurementId: 'G-PJY42Q6L9R',
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
